import { NgOptimizedImage } from '@angular/common';
import { Component, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { PortalNotificationType } from '@app/core/interfaces/portal-notification';
import { DialogService } from '@app/shared/dialog/dialog.service';
import { SharedModule } from '@app/shared/shared.module';
import { PortalTranslateService } from '@app/translate/services/portal-translate.service';
import { componentState } from '@app/utils/component-state';
import { MyNotificationsDialogComponent } from '@business/notification/components/my-notifications-dialog/my-notifications-dialog.component';
import { MyNotificationsDropdownItemComponent } from '@business/notification/components/my-notifications-dropdown-item/my-notifications-dropdown-item.component';
import { PortalNotificationService } from '@business/notification/portal-notification.service';

@Component({
  selector: 'portal-my-notifications-dropdown',
  standalone: true,
  imports: [SharedModule, NgOptimizedImage, MyNotificationsDropdownItemComponent],
  templateUrl: './my-notifications-dropdown.component.html',
  styles: ``,
})
export class MyNotificationsDropdownComponent {
  error = toSignal(this.portalNotificationService.myUnseenNotifications.error$);
  loading = toSignal(this.portalNotificationService.myUnseenNotifications.loading$);
  viewModel = toSignal(this.portalNotificationService.myUnseenNotifications.data$);

  generalItems = computed(
    () =>
      this.viewModel()?.notifications.filter(
        (notification) => notification.type === PortalNotificationType.GENERAL
      ) ?? []
  );

  noUnseen = computed(() => this.generalItems().length === 0);
  language = toSignal(this.portalTranslateService.activeLanguage$);
  state = componentState();

  constructor(
    private dialogService: DialogService,
    private portalNotificationService: PortalNotificationService,
    private portalTranslateService: PortalTranslateService
  ) {}

  markAllAsSeen(): void {
    this.state.handle(this.portalNotificationService.markAllAsSeen()).subscribe();
  }

  showAllNotifications(): void {
    this.dialogService.open(MyNotificationsDialogComponent);
  }
}
